// extracted by mini-css-extract-plugin
export default {"overlay":"movingReview_overlay__p1yLl","container":"movingReview_container__RIa1s"};